import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Credit.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import axios from "axios";
import Address from "../Modules/Address";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import Cookies from 'js-cookie'
import AppBody from "./AppBody";
import User from "../Modules/User";
class Credit extends React.Component{
    list =[];

    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            error: false,
            error_text: "",
            loading: false,
            dialogHasConfirm:false,
            credit:ls.get("user").balance,
            addAmount:null,
            giftCode:null,

        };
    }

    componentDidMount(){
        this.PaymentCheck();
        this.getUserData();
    };

    render() {
        let nextButton = (
            <button id={"posBtn"} onClick={()=>{this.pay(0)}}>
                <img src={`${process.env.PUBLIC_URL}/assets/images/pos.png`} className={"posImg"}/> درب منزل
            </button>
        );
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);

        let dialogConfirm = "";
        if(this.state.dialogHasConfirm)
            dialogConfirm = (
                <Button onClick={this.handleConfirm} color="success" autoFocus>
                    تایید
                </Button>
            );
        return (
            <AppBody loading={this.state.loading} name={"افزایش اعتبار"} type={" alice"}>
                <div id={"creditIcon"}>
                    <img src={`${process.env.PUBLIC_URL}/assets/images/addcrediticon.png`} id={"creditImg"}/>
                </div>

                <div id={"creditAmount"}>اعتبار فعلی : {new Intl.NumberFormat("fa").format(this.state.credit)} تومان</div>
                <div id={"creditInfoText"}>لطفا مبلغ اقزایش اعتبار را وارد نمایید</div>
                <input id={"amountInput"} placeholder={"مبلغ"} type={"number"} value={this.state.addAmount} onChange={this.changeAmount}/>
                <div id={"amountToman"}>تومان</div>
                <button id={"creditPay"} onClick={this.handleConfirm}>پرداخت</button>
                <div id={"giftDiv"}>
                    <div id={"giftFragment"}>
                        <div id={"giftImgDiv"}>
                            <img src={`${process.env.PUBLIC_URL}/assets/images/gift_card.png`} id={"giftImg"}/>
                        </div>
                        <input id={"giftInput"} placeholder={"کد کارت هدیه خود را وارد نمایید"} type={"text"} value={this.state.giftCode} onChange={this.changeGiftCode}/>
                    </div>
                    <button id={"giftCheck"} onClick={this.checkGiftCard}>اعمال</button>
                </div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            بستن
                        </Button>
                        {dialogConfirm}
                    </DialogActions>
                </Dialog>
            </AppBody>
        );
    }

    handleClose  = () => {
        this.setState({open:false})
    };
    changeGiftCode  = (e) => {
        this.setState({giftCode:e.target.value})
    };
    changeAmount  = (e) => {
        this.setState({addAmount:e.target.value})
    };
    handleDiscountChange  = (event) => {
        this.setState({discount_code: event.target.value});
    };
    payTypeHandler(type){
        this.setState({payment_type:type});
    }
    handleConfirm = () =>{
        this.setState({
            loading:true,
        });
        let data = {
            money:this.state.addAmount,
            token:ls.get("token"),
        };
        axios.post(urls.baseUrl+urls.payWallet,data)
            .then(res => {
                if(res.data.code == 200){
                    window.location = res.data.link;
                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogText:res.data.message,
                        dialogTitle:"خطا",
                        loading:false,
                    });
                }
            })
    };

    checkGiftCard = () =>{
        this.setState({
            loading:true,
        });
        let data = {
            giftCode:this.state.giftCode,
            token:ls.get("token"),
        };
        axios.post(urls.baseUrl+urls.checkGiftCard,data)
            .then(res => {
                if(res.data.code == 200){
                    alert("اعمال کارت هدیه با موفقیت انجام شد.")
                }
                else{
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogText:res.data.message,
                        dialogTitle:"خطا",
                        loading:false,
                    });
                }
            })
    };


    PaymentCheck = ()=>{
        let credit = Cookies.get('credit');
        if(credit == null)
            return;

        if(credit == 1){
            Cookies.remove('credit');
            alert("پرداخت با موفقیت انجام شد.");
        }
        else{
            alert("پرداخت ناموفق بود. لطفا مجددا تلاش کنید.");
            Cookies.remove('credit');
        }
    };

    getUserData(){
        axios.get(urls.baseUrl+urls.checkClient+"?token="+ls.get("token"))
            .then(res => {
                if(res.data.code == 200){
                    console.log("data : ",res.data);
                    let user = new User();
                    user.setData(res.data.user);
                    user.balance = res.data.wallet.balance;
                    user.countUnreadMessages = res.data.countUnreadMessages;
                    ls.set("user",user);
                    ls.set("city_id",user.city_id);
                    this.setState({gotUser:true,badUser:false});
                }
                else{
                    ls.remove("user");
                    ls.remove("token");
                    ls.remove("phone");
                    this.setState({retry:false,gotUser:true,badUser:true,loading:false});
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,gotUser:false,badUser:true,loading:false});
            });
    }
}



export default Credit;
